import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  infoData: {
    organization: "",
    parent: null,
    name: "",
    trading_name: "",
    tax_id: "",
    country: "",
    registration_number: "",
    type: "",
    salesforce_id: "",
    account_manager_name: "",
    account_manager_email: "",
    timezone: "",
  },
};

const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    setInfoData: (state, action) => {
      state.infoData = { ...state.infoData, ...action.payload };
    },
    resetInfoData: (state) => {
      state.infoData = initialState.infoData;
    },
  },
});

export const { setInfoData, resetInfoData } = formSlice.actions;

export default formSlice.reducer;
